import { Button, Col, Input, Row, Select } from "antd";
import { ClearOutlined, SearchOutlined } from "@ant-design/icons";
import { debounce } from "lodash";

export function AnnouncementFilter({ filter, onFilterChange }) {
  const handleSearch = debounce((key, value) => {
    const newFilter = { ...filter, [key]: value, page: 1 };
    onFilterChange(newFilter);
  }, 300);

  const handleChange = (key, value) => {
    const newFilter = { ...filter, [key]: value, page: 1 };
    onFilterChange(newFilter);
  };

  const handleClear = () => {
    onFilterChange({ page: 1, limit: filter.limit || 10 });
  };

  const priorityOptions = [
    { value: "", label: "Tất cả mức độ" },
    { value: "low", label: "Thấp" },
    { value: "normal", label: "Bình thường" },
    { value: "high", label: "Cao" },
    { value: "urgent", label: "Khẩn cấp" },
  ];

  const statusOptions = [
    { value: "", label: "Tất cả trạng thái" },
    { value: "true", label: "Hoạt động" },
    { value: "false", label: "Ngừng hoạt động" },
  ];

  return (
    <Row gutter={16} style={{ marginBottom: 16 }}>
      <Col span={8}>
        <Input
          placeholder="Tìm kiếm tiêu đề..."
          onChange={(e) => handleSearch("search", e.target.value)}
          prefix={<SearchOutlined />}
          size="large"
          allowClear
        />
      </Col>
      <Col span={6}>
        <Select
          placeholder="Mức độ ưu tiên"
          style={{ width: "100%" }}
          size="large"
          options={priorityOptions}
          onChange={(value) => handleChange("priority", value)}
          value={filter.priority}
          allowClear
        />
      </Col>
      <Col span={6}>
        <Select
          placeholder="Trạng thái"
          style={{ width: "100%" }}
          size="large"
          options={statusOptions}
          onChange={(value) => handleChange("isActive", value)}
          value={filter.isActive}
          allowClear
        />
      </Col>
      <Col span={4}>
        <Button icon={<ClearOutlined />} onClick={handleClear} size="large">
          Xóa lọc
        </Button>
      </Col>
    </Row>
  );
}
